<template>
  <div class="BaseHistory">
    <v-container fluid>
      <v-row v-if="restorePanel">
        <v-col cols="6" lg="6" md="6" sm="12" xs="12">
          <BaseHistoryDetail
              :storeDocItemId="storeDocItemId"
              :restorePanel.sync="restorePanel"
              :activeHistoryId.sync="activeHistoryId"
              :windowHeight="windowHeight"
              :wsDetail="wsDetail"
          ></BaseHistoryDetail>
        </v-col>
        <v-col cols="6" lg="6" md="6" sm="12" xs="12">
          <BaseHistoryRestore
              :storeDocItemId="storeDocItemId"
              :activeHistoryId="activeHistoryId"
              :windowHeight="windowHeight"
              :wsRestore="wsRestore"
          ></BaseHistoryRestore>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12" lg="12" md="12" sm="12" xs="12">
          <BaseHistoryDetail
              :storeDocItemId="storeDocItemId"
              :restorePanel.sync="restorePanel"
              :windowHeight="windowHeight"
              :wsDetail="wsDetail"
          ></BaseHistoryDetail>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BaseHistoryDetail from "@/components/BaseHistory/BaseHistoryDetail";
import BaseHistoryRestore from "@/components/BaseHistory/BaseHistoryRestore";
import {mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'BaseHistory',
  props: {
    'storeDocItemId': {default: null},
    'windowHeight': {default: 800},
    'wsDetail': {default: '/ws/quote_history/'},
    'wsRestore': {default: '/ws/quote_history_restore/'},
  },
  components: {
    BaseHistoryRestore,
    BaseHistoryDetail,
  },
  computed: {
    ...mapFields('BaseHistoryDetail', {'wsDetailUrl': 'wsUrl'}),
    ...mapFields('BaseHistoryRestore', {'wsRestoreUrl': 'wsUrl'}),
  },
  created() {
    this.wsDetailUrl = this.wsDetail
    this.wsRestoreUrl = this.wsRestore
  },
  mounted() {
    this.wsDetailUrl = this.wsDetail
    this.wsRestoreUrl = this.wsRestore
  },
  data() {
    return {
      restorePanel: false,
      activeHistoryId: null,
    }
  },
};
</script>
